import ReportHorizonSequencingXRef from './ReportHorizonSequencingXRef';

export default class FilteredReport {
    filters: string;
    horizonSequences: ReportHorizonSequencingXRef[];
}


// WEBPACK FOOTER //
// ./src/models/FilteredReport.ts